module.exports = __webpack_public_path__ + "static/media/infoIcon.7c7a2159.svg";